import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { NAV_PATHS } from '../navigation/paths.ts'
import { entryRoute } from './entry.tsx'

// The public end of a club's own enrolment link, a sheet of the entrance: no session is asked for,
// because nobody holds an account at this stage — the token is the only credential.

export interface IscrizioneSearch {
  readonly token: string
}

/** An absent or mangled token is a rendered outcome, not a throw — see `parseToken` in
 *  `routes/activation.tsx`, the pattern this mirrors. */
export function parseToken(value: unknown): string {
  return typeof value === 'string' ? value : ''
}

export const iscrizioneRoute = createRoute({
  getParentRoute: () => entryRoute,
  path: NAV_PATHS.enrolment,
  validateSearch: (search: Record<string, unknown>): IscrizioneSearch => ({
    token: parseToken(search.token),
  }),
  component: lazyRouteComponent(() => import('../pages/iscrizione.tsx')),
})
